import styled from "styled-components";
import Button from "components/Button";
import Paper from "@mui/material/Paper";

const Container = styled.div`
  padding: 20px;
`;

const AddSectionContainer = styled.div`
  margin: 15px 0;
`;

const AddSectionHeader = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  button {
    background-color: #1594db;
    border-radius: 6px;
    font-size: 16px;
    font-family: "Inter500";
    color: #fff;
    text-transform: capitalize;
    :hover {
      background-color: #1594db;
      color: #fff;
    }
  }
`;

const AddSectionButton = styled(Button)``;

const Card = styled.div`
  min-height: 200px;
  background: white;
  border-radius: 10px;
  margin-bottom: 15px;
  padding: 20px;
`;

const CardTitle = styled.h2`
  margin: 0;
  font-size: 16px;
  color: #2789c0;
  font-family: "Inter600";
  margin: 15px 0;
`;

const Row = styled.div`
  display: flex;
  grid-gap: 30px;
  margin-bottom: 30px;
  align-items: center;
  .MuiFormControl-root {
    width: 100%;
  }

  textarea {
    width: 100%;
    height: 100px;
  }
`;

const SectionNavbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 15px 0 30px;
  border-bottom: 2px solid #f0f0f0;
  h2 {
    color: #2789c0;
    font-family: "Inter600";
    font-size: 20px;
  }
  .MuiFormControlLabel-root {
    margin-right: 0;
  }
`;
const TextAreaWrapper = styled.div`
  margin-top: 20px;
`;

const TextFieldWrapperIcon = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  .MuiFormControl-root {
    width: 100%;
  }
  input {
    padding-right: 44px;
  }
  .delete-icon {
    position: absolute;
    right: 9px;
    cursor: pointer;
    color: #ff0000;
  }
`;

const FourBoxWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 30px;
  margin-bottom: 30px;
  @media (max-width: 1023px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (max-width: 767px) {
    grid-template-columns: 1fr;
  }
`;

const ThreeBoxWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 30px;
  margin-bottom: 30px;
  @media (max-width: 1023px) {
    grid-template-columns: 1fr;
  }
`;

const TwoBoxWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 30px;
  margin-bottom: 30px;
  @media (max-width: 1023px) {
    grid-template-columns: 1fr;
  }
`;
const OneBoxWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 30px;
  margin-bottom: 30px;
`;

const DashboardContainer = styled.div`
  width: ${(props) => (props?.$isAdmin ? "calc(100% - 300px)" : "100%")};
  flex: ${(props) => (props?.$isAdmin ? "auto" : "1")};
  min-width: 0;
`;
const DashboardNoDataFound = styled.div`
  padding: 20px;
  text-align: center;
  font-size: 20px;
  color: red;
  font-weight: bold;
`;

const DashboardHeader = styled.div`
  text-align: right;
  margin-bottom: 10px;
  svg {
    color: #1594db;
    cursor: pointer;
  }
`;

const DashboardAddSection = styled.div`
  min-width: 400px;

  .MuiTextField-root {
    width: 100%;
    margin-bottom: 10px;
  }
`;

const DashboardAddSubSection = styled.div`
  display: flex;
  gap: 20px;
  flex-direction: column;

  .MuiTextField-root {
    margin-bottom: 10px;
  }
`;

const DashboardSectionContainer = styled.div``;
const Section = styled.div`
  padding: ${(props) => (props?.$isAdmin ? "20px" : "0")};
  margin-bottom: 10px;
`;
const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${(props) => (props?.$isAdmin ? "20px" : "0")};

  h2 {
    margin: 0;
    font-family: "Inter800";
    font-size: ${(props) => (!props?.$isAdmin ? "36px" : "auto")};
    display: ${(props) => (!props?.$isAdmin ? "none" : "block")};
  }
  svg {
    color: red;
    cursor: pointer;
  }
`;

const SectionBody = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;

  @media screen and (max-width: 1300px) {
    grid-template-columns: repeat(4, 1fr);
  }

  @media screen and (max-width: 800px) {
    grid-template-columns: repeat(2, 1fr);
  }

  ${(props) =>
    !props?.$isAdmin &&
    `
    display: flex;
    flex-wrap: nowrap;
    gap: 14px;
    width: 100%;

    @media screen and (max-width: 800px) {
      overflow-x: auto;
      padding-bottom: 4px;
      -webkit-overflow-scrolling: touch;
    }
  `}
`;
const AddSubSection = styled.div`
  border: 2px dashed #1594db;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  height: 200px;
  svg {
    color: #1594db;
  }
`;

const SubSectionWrapper = styled.div`
  height: 200px;
  transition:
    transform 0.15s ease,
    opacity 0.15s ease;
  user-select: ${(props) => (props.$isAdmin ? "none" : "auto")};

  ${(props) =>
    !props?.$isAdmin &&
    `
    flex: 1;
    min-width: 0;
    height: 170px;

    @media screen and (max-width: 800px) {
      flex: 0 0 140px;
      min-width: 140px;
    }
  `}

  &.dragging {
    opacity: 0.45;
  }

  &.drag-over {
    transform: scale(1.02);
  }

  &.inactive .MuiPaper-rounded {
    opacity: 0.55;

    .card-actions {
      opacity: 1;
    }
  }

  .MuiPaper-rounded {
    cursor: ${(props) => (props.$isAdmin ? "grab" : "pointer")};
    height: 100%;
    border-radius: 10px;
    width: 100%;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    transition: box-shadow 0.2s ease;

    .card-actions {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 6px;
      z-index: 2;
      opacity: 0;
      transition: opacity 0.2s ease;
      pointer-events: none;

      .card-actions-left,
      .card-actions-right {
        display: flex;
        align-items: center;
        gap: 4px;
        pointer-events: auto;
      }

      svg {
        font-size: 20px;
        cursor: pointer;
        background: rgba(255, 255, 255, 0.95);
        border-radius: 50%;
        padding: 3px;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
      }

      svg.drag-handle {
        color: #666;
        cursor: grab;
      }

      svg.edit-icon {
        color: #e67e00;
      }

      svg.visibility-icon {
        color: #1594db;
      }

      svg.visibility-icon.inactive {
        color: #999;
      }

      svg.delete-icon {
        color: #e53935;
      }
    }

    .img {
      background-repeat: no-repeat;
      background-size: contain;
      flex: 1;
      min-height: 0;
      background-position: 50% 50%;
      background-color: white;
      padding: ${(props) => (props.$isAdmin ? "0" : "0")};
      box-sizing: border-box;
    }

    .img-wrapper {
      flex: 1;
      min-height: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 14px 12px;
      box-sizing: border-box;
      background-color: white;
      overflow: hidden;

      img {
        max-width: 100%;
        max-height: 100%;
        width: auto;
        height: auto;
        object-fit: contain;
        display: block;
      }
    }

    .card-title {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 100%;
      margin: 0;
      padding: ${(props) => (props.$isAdmin ? "10px" : "8px 6px")};
      text-align: center;
      font-weight: bold;
      font-size: ${(props) => (props.$isAdmin ? "inherit" : "12px")};
      background-color: #f5f8fa;
      transition:
        background-color 0.2s ease,
        color 0.2s ease;
    }

    &:hover {
      box-shadow: 0 6px 16px rgba(21, 148, 219, 0.25);

      .card-actions {
        opacity: 1;
      }

      .card-title {
        background-color: ${(props) =>
          props.$isAdmin ? "#1594db" : "#f5f8fa"};
        color: ${(props) => (props.$isAdmin ? "#fff" : "inherit")};
      }
    }

    &:active {
      cursor: grabbing;
    }
  }

  &.drag-over .MuiPaper-rounded {
    outline: 2px dashed #1594db;
    outline-offset: -2px;
  }
`;

const StyledPaper = styled(Paper)`
  &.MuiPaper-root {
    box-shadow: ${(props) => (props?.$isAdmin ? "" : "none")};
    background-color: ${(props) => (props?.$isAdmin ? "#fff" : "transparent")};
    margin-bottom: ${(props) => (props?.$isAdmin ? "40px" : "0")};
  }
`;

export {
  Container,
  AddSectionContainer,
  AddSectionHeader,
  AddSectionButton,
  Card,
  CardTitle,
  Row,
  SectionNavbar,
  TextAreaWrapper,
  TextFieldWrapperIcon,
  FourBoxWrapper,
  ThreeBoxWrapper,
  TwoBoxWrapper,
  OneBoxWrapper,
  DashboardContainer,
  DashboardNoDataFound,
  DashboardHeader,
  DashboardAddSection,
  DashboardSectionContainer,
  Section,
  SectionHeader,
  SectionBody,
  AddSubSection,
  DashboardAddSubSection,
  SubSectionWrapper,
  StyledPaper,
};
